/**
 * The chat's opening message: instant (no LLM round-trip), deterministic, and
 * personalized from what the widget already knows.
 *
 * MOTIVATION-FIRST. It asks what drew the customer to the product, not what is
 * making them leave. That is a deliberate trade: it costs one extra exchange
 * before the first save can land, and it buys `whyBought` on every conversation
 * plus an opening that is warm rather than defensive. There is no apology and no
 * tenure padding — "less is more".
 *
 * The CANCEL question is the model's first reply, not part of this greeting.
 *
 * It speaks about the SUBJECT (see shared/cancel-subject), not the clicked
 * product: on a multi-line contract the customer is cancelling all of it.
 *
 * KEEP IN SYNC with the phase-1 system prompt in src/lib/cancel-chat/prompt.ts
 * (server), which tells the model this question has ALREADY been asked — the
 * customer's first message is their answer to it.
 */
export function buildCancelGreeting(args: {
  /** From buildCancelSubject(...).text — the product, both products, or "your subscription". */
  subjectText: string;
  firstName: string | null;
}): string {
  const name = args.firstName?.trim() || null;
  const question = `what drew you to ${args.subjectText} to begin with?`;
  return name
    ? `Hi ${name}, ${question}`
    : `${question.charAt(0).toUpperCase()}${question.slice(1)}`;
}
